<script setup lang="ts">
export interface CallDetailsMetadataRow {
  id: string
  label: string
  value: string | null
  private?: boolean
}

defineProps<{
  row: CallDetailsMetadataRow
}>()
</script>

<template>
  <div
    class="grid grid-cols-[max-content_minmax(0,1fr)] items-start gap-xl typography-body-2"
    :data-testid="`${row.id}-row`"
  >
    <span class="shrink-0 typography-body-2-strong" :data-testid="`${row.id}-label`">
      {{ row.label }}
    </span>
    <span
      v-if="row.private && row.value !== null"
      v-mp-no-track
      class="min-w-0 text-end whitespace-normal [overflow-wrap:anywhere]"
      :data-testid="`${row.id}-value`"
    >
      {{ row.value }}
    </span>
    <span
      v-else-if="row.value !== null"
      class="min-w-0 text-end whitespace-normal [overflow-wrap:anywhere]"
      :data-testid="`${row.id}-value`"
    >
      {{ row.value }}
    </span>
  </div>
</template>
